'use client'

import React, { useEffect, useState } from 'react'
import api from '../../lib/api.interceptor'
import { usePathname } from 'next/navigation'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setThankYouData } from '../../store/features/projectSlice'
import { useRouter } from 'next/navigation'
import {
  setIsOpenInq,
  setProjectsFullListDetail
} from '../../store/features/projectSlice'
import { Toast } from './Toast'

function Header_inquiry({
  // isOpenInq,
  // setIsOpenInq,
  // contactDetailData,
  // propertylist,
  // pageList,
  // // projects_full_list_detail,
  // countryList

  contactDetailData,
  propertylist,
  pageList
}) {
  const activePath = usePathname()

  const countryList = useSelector((state) => state.project.countryList)

  const dispatch = useDispatch()
  const isOpenInq = useSelector((state) => state.project.isOpenInq)
  const projects_full_list_detail = useSelector(
    (state) => state.project.projects_full_list_detail
  )
  const router = useRouter()

  const [contactData, setContactData] = useState(contactDetailData || null)
  const [isMobilescreen, setMobilescreen] = useState(false)
  const [projects_name, setProjects_name] = useState('')

  const [formData, setFormData] = useState({
    // project_id: projects_full_list_detail
    //   ? projects_full_list_detail.project_id
    //   : "",
    project_id: '',
    agree_tandc: '1',
    agree_tandc_display: 'true',
    logged_in_master_user_id: 239,
    master_user_id: 239,
    from_app: 'true',
    user_type: 'N',
    inquiry_from: 'web',
    client_name: '',
    email_address: '',
    client_contact_no_display: '',
    client_contact_no: '',
    country: '91',
    flag: 'https://flagcdn.com/w40/in.webp',
    remarks: ''
  })

  const [countrySearch, setCountrySearch] = useState('')
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  // useEffect(() => {
  //   console.log(activePath)
  // }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    // console.log(name, value)
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleKeyDownPhone = (e) => {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete'
    ]

    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault()
    }
  }

  const handleCountrySelect = (phonecode, flag) => {
    setFormData((prev) => ({
      ...prev,
      country: phonecode,
      flag: flag
    }))
    setCountryDropdownOpen(false)
  }

  const inquiryform = async (e) => {
    e.preventDefault()
    const validationErrors = validate()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }
    formData.project_id = formData.project_id
      ? formData.project_id
      : projects_full_list_detail.project_id
    formData.client_contact_no =
      formData.country + ' ' + formData.client_contact_no_display
    const projectDetail = projects_full_list_detail.project_id
      ? projects_full_list_detail
      : propertylist.find((p) => p.project_id == formData.project_id)
    setCountryDropdownOpen(false)
    setIsSubmitting(true)
    // console.log('Submit Data:', formData)
    const response = await api.Projectinquiry(formData)
    if (response.success == 1) {
      setIsSubmitting(false)
      setErrors({})
      dispatch(setIsOpenInq(false))
      // navigate(`/${projectDetail.slug}/thank_you`, {
      //   state: {
      //     page_name: projectDetail.project_title,
      //     document: projectDetail.document_other_data
      //       ? projectDetail.document_other_data
      //       : []
      //   }
      // })

      dispatch(
        setThankYouData({
          page_name: projectDetail.project_title,
          document: projectDetail.document_other_data
            ? projectDetail.document_other_data
            : []
        })
      )
      router.push(`/${projectDetail.slug}/thankyou`)

      Toast(response.message)
      setFormData({
        project_id: '',
        agree_tandc: '1',
        agree_tandc_display: 'true',
        logged_in_master_user_id: 239,
        master_user_id: 239,
        from_app: 'true',
        user_type: 'N',
        inquiry_from: 'web',
        client_name: '',
        email_address: '',
        client_contact_no_display: '',
        client_contact_no: '',
        country: '91',
        flag: 'https://flagcdn.com/w40/in.webp',
        remarks: ''
      })
    } else {
      setIsSubmitting(false)
      Toast(response.message)
    }
  }

  const validate = () => {
    const newErrors = {}

    if (!formData.client_name.trim())
      newErrors.client_name = 'Full name is required.'
    if (!formData.remarks.trim() && activePath == '/goodwill-Tower')
      newErrors.remarks = 'This field is required.'
    if (!formData.project_id && !projects_full_list_detail)
      newErrors.project_id = 'This field is required.'
    if (!formData.email_address.trim()) {
      newErrors.email_address = 'Email is required.'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_address)) {
      newErrors.email_address = 'Invalid email format.'
    }
    if (!formData.client_contact_no_display.trim()) {
      newErrors.client_contact_no_display = 'Phone number is required.'
    } else if (!/^[0-9]+$/.test(formData.client_contact_no_display)) {
      newErrors.client_contact_no_display = 'Please enter a valid phone number.'
    }

    return newErrors
  }

  const validateField = (name, value) => {
    let error = ''

    if (name === 'client_name' && !value.trim()) {
      error = 'Full name is required.'
    }

    if (name === 'email_address') {
      if (!value.trim()) {
        error = 'Email is required.'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = 'Invalid email format.'
      }
    }

    if (name === 'client_contact_no_display') {
      if (!value.trim()) {
        error = 'Phone number is required.'
      } else if (!/^[0-9]+$/.test(value)) {
        error = 'Please enter a valid phone number.'
      }
    }

    return error
  }

  useEffect(() => {
    setFormData({
      project_id: '',
      agree_tandc: '1',
      agree_tandc_display: 'true',
      logged_in_master_user_id: 239,
      master_user_id: 239,
      from_app: 'true',
      user_type: 'N',
      inquiry_from: 'web',
      client_name: '',
      email_address: '',
      client_contact_no_display: '',
      client_contact_no: '',
      country: '91',
      flag: 'https://flagcdn.com/w40/in.webp',
      remarks: ''
    })
  }, [isOpenInq])

  useEffect(() => {
    let contactDData = {}
    if (contactData == null) {
      // console.log(pageList);
      contactDData = pageList.find((page) => page.slug == 'contact-us')
      setContactData(contactDData)
      // console.log(contactDData);
    }
    // console.log(projects_full_list_detail);

    if (window.innerWidth < 767) setMobilescreen(true)
  }, [])

  useEffect(() => {
    if (projects_full_list_detail) {
      setProjects_name(projects_full_list_detail.project_title)
      setFormData((prev) => ({
        ...prev,
        project_id: projects_full_list_detail.project_id
      }))
    } else {
      setProjects_name('')
      setFormData((prev) => ({
        ...prev,
        project_id: ''
      }))
    }
  }, [projects_full_list_detail])

  function inquire_popup_web_toggle_close() {
    dispatch(setIsOpenInq(false))
  }

  return (
    <>
      <div className={`side_popup_wrapper ${isOpenInq ? 'inqury_active' : ''}`}>
        <div className="inquiry_popup relative">
          <div
            className="close_icon"
            onClick={() => {
              inquire_popup_web_toggle_close()
              //   country_code_click_false();
            }}
          >
            {contactData && (
              <img src="/images/icons/close.svg" alt={contactData.page_name} />
            )}
          </div>
          <div>
            <div className="side_popup_in">
              <div className="section-information">
                <div className="section-title">
                  {projects_full_list_detail ? (
                    projects_full_list_detail.project_id != 621 && (
                      <p className="uppercase">
                        {projects_full_list_detail.project_id == 602
                          ? 'Register your Interest'
                          : 'Book Your Site Visit'}
                      </p>
                    )
                  ) : (
                    <p className="uppercase">Book Your Site Visit</p>
                  )}

                  {projects_full_list_detail &&
                    projects_full_list_detail.project_id == 621 && (
                      <p>Enquire Now</p>
                    )}
                </div>
                {projects_name && (
                  <div className="content-size-div">
                    <p className="capitalize">{projects_name}</p>
                  </div>
                )}
              </div>
              <form
                id="inquiry_form"
                name="inquiry_form"
                onSubmit={inquiryform}
              >
                <div className="form_wrapper">
                  {/* Project dropdown */}
                  {/* {projects_full_list_detail} */}
                  {!projects_full_list_detail == [] &&
                    !projects_full_list_detail.project_id && (
                      <div className="contact_lable select_option select_apr relative">
                        <select
                          name="project_id"
                          className={`form-control ${
                            errors.project_id ? 'error' : ''
                          }`}
                          id="project_id"
                          value={formData.project_id}
                          onChange={handleChange}
                          // required
                        >
                          <option value="" disabled>
                            Select Project
                          </option>
                          {propertylist.map((data, i) => (
                            <option
                              key={i}
                              value={data.project_id}
                              className="capitalize"
                            >
                              {data.project_title}
                            </option>
                          ))}
                        </select>
                        <label
                          className="md-lable project_id_label"
                          htmlFor="project_id"
                        >
                          Project*
                        </label>
                        <div className="fa-icon">
                          <span className="material-symbols-outlined">
                            stat_minus_1
                          </span>
                        </div>
                      </div>
                    )}
                  {/* Full Name */}
                  <div className="contact_lable">
                    <input
                      id="name"
                      name="client_name"
                      type="text"
                      value={formData.client_name}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.client_name ? 'error' : ''
                      }`}
                      // required
                      autoComplete="off"
                    />
                    <label className="md-lable" htmlFor="name">
                      Full Name*
                    </label>
                  </div>
                  {/* Email */}
                  <div className="contact_lable">
                    <input
                      id="email"
                      name="email_address"
                      type="email"
                      value={formData.email_address}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.email_address ? 'error' : ''
                      }`}
                      autoComplete="off"
                    />
                    <label className="md-lable" htmlFor="email">
                      Email Address
                    </label>
                  </div>
                  {/* Phone with Country Code */}
                  <div className="contact_lable relative">
                    <input
                      id="client_contact_no"
                      name="client_contact_no_display"
                      type="tel"
                      value={formData.client_contact_no_display}
                      onChange={handleChange}
                      onKeyDown={handleKeyDownPhone}
                      maxLength="10"
                      minLength="10"
                      className={`form-control contact-form ${
                        errors.client_contact_no_display ? 'error' : ''
                      }`}
                      // required
                      autoComplete="off"
                    />
                    <label className="md-lable" htmlFor="client_contact_no">
                      Phone Number*
                    </label>

                    <div className="conatct_number_input">
                      <div
                        className="country_code_data"
                        onClick={() =>
                          setCountryDropdownOpen(!countryDropdownOpen)
                        }
                      >
                        <div className="contact_country_flag">
                          <img src={formData.flag} alt="flag" />
                        </div>
                        <div>&nbsp; +{formData.country}</div>
                        <div>
                          <span className="material-symbols-outlined">
                            keyboard_arrow_down
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Country dropdown */}
                    <div
                      className={`country_code_list_data ${
                        countryDropdownOpen ? 'active' : ''
                      }`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="search_c-code">
                        <input
                          type="text"
                          placeholder="Search"
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                        />
                      </div>
                      <ul>
                        {countryList
                          .filter(
                            (country) =>
                              country.phonecode.includes(countrySearch) ||
                              country.nicename
                                .toLowerCase()
                                .includes(countrySearch.toLowerCase())
                          )
                          .map((country, i) => (
                            <li
                              key={i}
                              onClick={() =>
                                handleCountrySelect(
                                  country.phonecode,
                                  country.flag
                                )
                              }
                            >
                              <div>
                                <div>
                                  <img
                                    src={country.flag}
                                    alt={country.nicename}
                                  />
                                </div>
                                <span className="display_country_code">
                                  +{country.phonecode}
                                </span>
                                {country.nicename}
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                    {countryDropdownOpen && (
                      <div
                        className="country-overlay"
                        onClick={() => {
                          setCountryDropdownOpen(false)
                        }}
                      ></div>
                    )}
                  </div>
                  {/* Message or Tenure field */}
                  {activePath === '/goodwill-Tower' ? (
                    <div className="contact_lable commentbox">
                      <select
                        id="remarks"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.remarks ? 'error' : ''
                        }`}
                      >
                        <option value="" style={{ display: 'none' }}></option>
                        <option value="1 Year">1 Year</option>
                        <option value="3 Years">3 Years</option>
                        <option value="5 Years">5 Years</option>
                        <option value="More than 5 Years">
                          More than 5 Years
                        </option>
                      </select>
                      <label className="md-lable" htmlFor="remarks">
                        Tenure
                      </label>
                    </div>
                  ) : (
                    <div className="contact_lable commentbox">
                      <textarea
                        id="remarks"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        className="form-control"
                        rows="4"
                      />
                      <label className="md-lable" htmlFor="remarks">
                        Message
                      </label>
                    </div>
                  )}
                  {/* Submit Button */}
                  <div className="filled-div-button button-div">
                    <button
                      className="button-style black-btn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      <div
                        className="loading_btn"
                        style={{
                          display: isSubmitting ? 'inline-block' : 'none'
                        }}
                      ></div>
                      <p>{isSubmitting ? 'Please Wait...' : 'Submit'}</p>
                    </button>
                  </div>
                  {/* Consent Line */}
                  <p className="consecnt-line-text">
                    *By clicking on submit, you agree to the
                    <a
                      href="privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    of Venus Infra.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
//   <div>
//     <div className="side_popup_in">
//       <div className="section-information">
//         <div className="section-title">
//           {propertylist.project_id != 621 && (
//             <p>
//               {propertylist.project_id == 602
//                 ? "Register your Interest"
//                 : "Book Your Site Visit"}
//             </p>
//           )}
//           {propertylist.project_id == 621 && <p>Enquire Now</p>}
//         </div>
//         {projects_name && (
//           <div className="content-size-div">
//             <p className="capitalize">{projects_name}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   </div>

export default Header_inquiry
